import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { emailListIsValid } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { Button, Form, Row, Typography, Select, Divider } from 'antd'
import { CustomSelect, CustomInputNumber, CustomTextArea } from 'src/components'
import { SmallProjectIntegration, StockAlertPostPayload } from 'src/core/models'
import {
  allProjectsIntegrationSelector,
  createStockAlertSelector,
  createStockAlert,
} from 'src/features'
const { Title, Text } = Typography
const { Option } = Select

interface FormValues {
  project: number
  threshold: number,
  email_list: string
}

const StockAlertForm = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const [showEmailError, setShowEmailError] = useState(false)

  const { data: integrationProjects } = useAppSelector(allProjectsIntegrationSelector)
  const { loading: loadingCreate } = useAppSelector(createStockAlertSelector)

  const onFinish = (values: FormValues) => {
    if (!emailListIsValid(values.email_list)) {
      setShowEmailError(true)
      return
    }
    setShowEmailError(false)
    const payload: StockAlertPostPayload = {
      ...values, email_list: values.email_list.split(',')
    }
    dispatch(createStockAlert(payload))
  }

  return (
    <>
      <Form
        name='stockAlertForm'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        {/* Project */}
        <Title level={5} type={'secondary'}>{t('Offers.Project')}</Title>
        <CustomSelect
          name='project'
          required
          placeholder={t('StockAlert.ProjectPlaceHolder')}>
          {integrationProjects.map((project: SmallProjectIntegration) => (
            <Option key={project.id}>
              {project.name} <strong>{project.average} %</strong>
            </Option>
          ))}
        </CustomSelect>

        {/* Threshold */}
        <Title level={5} type={'secondary'}>{t('StockAlert.Threshold')}</Title>
        <CustomInputNumber
          name='threshold'
          placeholder={t('StockAlert.ThresholdPlaceHolder')}
          min={1}
          max={100}
          required
        />

        {/* Email List */}
        <Title level={5} type={'secondary'}>{t('StockAlert.Emails')}</Title>
        <CustomTextArea
          name='email_list'
          placeholder={t('StockAlert.EmailsPlaceholder')}
          required
        />

        {showEmailError && <Text type='danger'>{t('StockAlert.EmailsError')}</Text>}

        {/* Buttons */}
        <Divider />
        <Row className='is-align-content-center'>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            className='radius-100'
            shape='round'
            block
            loading={false}
          >
            {loadingCreate ? t('StockAlert.Creating') : t('StockAlert.Create')}
          </Button>
        </Row>
      </Form>
    </>
  )
}

export default StockAlertForm
